import { render, staticRenderFns } from "./RequestSetup.vue?vue&type=template&id=444b69e0&"
import script from "./RequestSetup.vue?vue&type=script&lang=js&"
export * from "./RequestSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports